import React, { Component } from 'react';
import T from 'prop-types';
// redux
import { connect } from 'react-redux';
// components
import OfflineScreen from 'components/OfflineScreen';
// utils
import { FormattedMessage } from 'react-intl';
// styles
import './ImportTable.scss';
import { setPageOptions } from '../../../../reducers/layout';
import { setBreadcrumbs } from '../../../../reducers/breadcrumbs';
import ColumnsTable from './ColumnsTable/ColumnTable';
import once from 'lodash.once';
import { setSelectedArchiveImports } from '../../../../reducers/importCSV';
// regional date handling
import { getCurrentCountryCode } from 'selectors/regionalDateSelectors';
import { formatDateForUserShort } from 'utils/regionalDateHelper';

const links = [
  { backLink: '/imports', label: <FormattedMessage id="general.imports.table" /> },
];

class ImportTable extends Component {

  componentDidMount() {
    const { setPageOptions, setBreadcrumbs } = this.props;
    setPageOptions({ links });
    setBreadcrumbs();
  }

  componentWillUnmount() {
    this.props.setPageOptions({ links: null });
  }

  setHeaderList = once((results) => {
    const { setSelectedArchiveImports, setPageOptions, setBreadcrumbs } = this.props;
    setPageOptions({ links: null });
    setSelectedArchiveImports(results);
    const columnsType = {
      groups: 'Groups',
      barns: 'Barns',
      bins: 'Bins',
      farms: 'Farms',
      users: 'Users',
    };
    const types = results.type || [];
    const nameLink = `${types.map((type) => columnsType[type] || type).join(', ')} ${
      formatDateForUserShort(results.created_at, this.props.countryCode)
    }`;
    return (
      setBreadcrumbs([
        { label: <FormattedMessage id="general.pageTitle.imports" />, path: '/imports' },
        { label: nameLink, path: `/imports/${results.id}/${types[0]}`, useLabelAsMobileTitle: true },
      ])
    );
  });

  render() {
    const { isOnline } = this.props;
    return (
      <div className="wrapperApi">
        <div className="BarnsheetsHome clearfix">
          {isOnline
            ? (
              <div className="small-12 column">
                <ColumnsTable
                  setHeaderList={this.setHeaderList}
                />
              </div>
            )
            : <OfflineScreen />}
        </div>
      </div>
    );
  }
}

ImportTable.propTypes = {
  isOnline: T.bool,
  setPageOptions: T.func,
  setBreadcrumbs: T.func,
  setSelectedArchiveImports: T.func,
  countryCode: T.string,
};

export default connect(
  (state) => ({
    isOnline: state.network.isOnline,
    countryCode: getCurrentCountryCode(state),
  }),
  { setPageOptions, setBreadcrumbs, setSelectedArchiveImports }
)(ImportTable);
